import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Navbar, NavbarGroup } from '@blueprintjs/core';
import 'src/styles/components/_subNavBar.scss';

const ARNavBar: React.FC = () => {
    type page = 'deposit-invoice-reconciliation' | 'past-due-invoices' | 'ar-history' | 'icco-breakdown';

    const dispatch = useDispatch();
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/deposit-invoice-reconciliation') >= 0) {
            setCurrentSection('deposit-invoice-reconciliation');
        } else if (window.location.pathname.indexOf('/past-due-invoices') >= 0) {
            setCurrentSection('past-due-invoices');
        } else if (window.location.pathname.indexOf('/history') >= 0) {
            setCurrentSection('ar-history');
        } else if (window.location.pathname.indexOf('/icco-breakdown') >= 0) {
            setCurrentSection('icco-breakdown');
        }
    });

    const navigate = (path: string) => {
        console.log(currentSection);
        if (window.location.pathname.includes('accounts-receivable/') && currentSection) {
            let newPath = path.replace('accounts-receivable/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="nav-bar">
            <NavbarGroup>
                <div className={'sub-nav-menu-item ' + isActive('deposit-invoice-reconciliation')} onClick={() => navigate('accounts-receivable/deposit-invoice-reconciliation')}>
                    Deposit/Invoice Reconciliation
                </div>
                <div className={'sub-nav-menu-item ' + isActive('past-due-invoices')} onClick={() => navigate('accounts-receivable/past-due-invoices')}>
                    Past Due Invoices
                </div>
                <div className={'sub-nav-menu-item ' + isActive('ar-history')} onClick={() => navigate('accounts-receivable/history')}>
                    A/R History
                </div>
                <div className={'sub-nav-menu-item ' + isActive('icco-breakdown')} onClick={() => navigate('accounts-receivable/icco-breakdown')}>
                    ICPO Breakdown
                </div>
            </NavbarGroup>
        </Navbar>
    );
};

export default ARNavBar;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/ARNavBar.tsx